import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import { fonts, palette } from '../../styles/variables'
import { getOS } from '../../utils/functions'
import { Text } from '../topography'
import PhoneCodeSelector, { getDialCode } from '../selector/PhoneCodeSelector'
import { translate } from '../../utils/translation'
import { selectCurrentUser } from '../../state/selectors'

const Wrapper = styled.div((props) => ({
  background: 'none',
  position: 'relative',
  ...(props.styles || {}),
}))

const InputWrapper = styled.div((props) => ({
  display: 'flex',
  border: `1px solid ${props.borderColor}`,
  alignItems: 'center',
  backgroundColor: `${props.backgroundColor} !important`,
}))

const Input = styled.input(
  ({
    width = '100%',
    height = '100%',
    backgroundColor = palette.white,
    placeholderColor = palette.gray,
  }) => ({
    height,
    width,
    padding: '10px 16px',
    fontSize: '14px',
    lineHeight: '16px',
    fontFamily: fonts.primary,
    backgroundColor: `${backgroundColor} !important`,
    outline: 'none',
    borderRadius: '2px',
    WebkitAppearance: 'none',
    border: 'none',
    '::placeholder': {
      color: placeholderColor,
      fontWeight: getOS() === 'Mac' ? 900 : '400',
    },
  }),
)

export const PhoneInput = ({
  onChange,
  styles,
  invalidMessage,
  backgroundColor,
  focusedBorderColor,
  initialPhoneCode,
  initialValue = '',
  ...rest
}) => {
  const user = useSelector(selectCurrentUser())
  const [phoneCode, setPhoneCode] = useState(
    initialPhoneCode || user.countryCode,
  )
  const [value, setValue] = useState(initialValue)
  const [borderColor, setBorderColor] = useState(palette.lightGray)

  useEffect(() => {
    if (!value) {
      onChange('')
    } else {
      onChange(`${getDialCode(phoneCode)} ${value}`)
    }
    // eslint-disable-next-line
  }, [phoneCode, value])

  return (
    <Wrapper styles={styles}>
      <InputWrapper backgroundColor={backgroundColor} borderColor={borderColor}>
        <PhoneCodeSelector
          placeholder={translate('country_code')}
          name="countryCode"
          value={phoneCode}
          width="56px"
          mobileWidth="56px"
          onChange={(changedValue) => {
            setPhoneCode(changedValue)
          }}
          hideLabel
          noBorder
          margin="0px"
          padding="0 14px"
          backgroundColor={palette.lightGray30}
          flagStyle={{ height: '12px', width: '14.67px' }}
          caretType="secondary"
          dropdownMaxWidth="330px"
        />
        <Input
          value={value}
          onChange={(e) => {
            setValue(e.target.value)
          }}
          style={{ flexGrow: 1, flexBasis: 0 }}
          backgroundColor={backgroundColor}
          onFocus={() => setBorderColor(focusedBorderColor)}
          onBlur={() => setBorderColor(palette.lightGray)}
          {...rest}
        />
      </InputWrapper>
      {invalidMessage && (
        <Text
          fontSize="12px"
          lineHeight="12px"
          color={palette.danger}
          margin="8px 0 0 0"
        >
          {invalidMessage}
        </Text>
      )}
    </Wrapper>
  )
}
